import { IconButton } from "@mui/material";
import React, { useContext } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { net } from "../../../../../database";
import { UserContext } from "../../../../../Context";
import IconButtonHT from "../../../components/IconButtonHT";
import mut from "../../../hooks/mut";
import VND from "../../../components/VND";
import Staff from "../../../components/Staff";
import Info from "../../../components/Info";

export default function BillsDetail(props) {

  let { student, setStudent } = props;
  const {user} = useContext(UserContext)

  const deleteBill = (id) => {
    net.del(`/bills/${id}`).then((unpaidBills) => {
      setStudent({ ...student, unpaidBills });
    });
  };

  return (
    <div>
      {props.bills.map((b, i) => (
        <div
          key={`b_id${i}`}
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: 5,
            fontSize: 14,
            lineHeight: 1,
            alignItems: "center",
            color: b.writtenOff ? "purple" : "black",
          }}
        >
          <div style={{ width: 150 }}><Info title={b.createdBy ? <Staff id={b.createdBy} />: "Auto bill"} body={b.billType} /></div>
          <div style={{ flexGrow: 1 }}>{b.writtenOff ? <div><div>{b.description}</div><div>Written off by {<Staff id={b.writtenOffBy} />} on {new Date(b.writtenOff).fDateTime()}</div></div> : b.description}</div>
          <div style={{ width: 100, textAlign: "right" }}>
            <VND value={b.amount} />
          </div>
          {user.roles.includes("Accountant") ? (
            <div>
              <IconButton
                sx={{ ml: 1 }}
                onClick={() => deleteBill(b._id)}
              >
                <DeleteIcon style={{ fontSize: 16, color: "red" }} />
              </IconButton>
              {!b.writtenOff && (
                <IconButtonHT
                  icon="x"
                  style={{ fontSize: 16, color: "purple", height: 10 }}
                  action={async () => {
                    let res = await mut("post", `/bills/${b._id}`, {
                      writtenOff: new Date(),
                      writtenOffBy: user._id,
                    });
                    if (res) {
                      let unpaidBills = student.unpaidBills.map((bill) =>
                        bill._id === b._id ? res : bill
                      );
                      setStudent({ ...student, unpaidBills });
                    }
                  }}
                />
              )}
            </div>
          ) : (
            ""
          )}
          
        </div>
      ))}
    
    </div>
  );
}
